<template>
  <v-card v-if="source" rounded="lg" class="mb-3">
    <v-card-title class="text-subtitle-1 pb-1">{{ source.name || "Source" }}</v-card-title>
    <v-card-text>
      <v-simple-table dense>
        <tbody>
          <tr v-for="item in items" :key="item.label">
            <td class="text-caption">{{ item.label }}</td>
            <td>{{ item.value }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>
<script>
import { canvasToMeep, wavelengthToFrequency } from "@/store/module-simulator/lib/units";

const TYPES = {
  continuous: "Continuous wave",
  gaussian: "Gaussian pulse",
  gaussian_beam: "Gaussian beam"
};

const fixed = (value, digits = 4) => {
  const number = Number(value);
  return Number.isFinite(number) ? Number(number.toFixed(digits)) : "-";
};

export default {
  name: "DetailsSourceCard",
  props: {
    source: { type: Object, default: null },
    // Estado salvo na produção 2D (célula e escala do canvas), para converter pixels em µm
    production: { type: Object, default: null },
    is3d: { type: Boolean, default: false }
  },
  computed: {
    items() {
      const source = this.source;
      const wavelength = Number(source.waveLength);
      const items = [];
      if (this.is3d) {
        items.push({ label: "Type", value: "Localized Gaussian current (polarized along x)" });
        items.push({ label: "Wavelength λ", value: `${fixed(wavelength)} µm` });
        items.push({ label: "Source size σ", value: `${fixed(source.waveWidth)} µm` });
        items.push({ label: "Position", value: `(${fixed(source.x, 3)}, ${fixed(source.y, 3)}, ${fixed(source.z, 3)}) µm` });
        return items;
      }

      const type = source.sourceType || "continuous";
      items.push({ label: "Type", value: TYPES[type] || type });
      items.push({
        label: "Wavelength λ",
        value: `${fixed(wavelength)} µm (f = ${fixed(wavelengthToFrequency(wavelength))} c/µm)`
      });
      items.push({ label: "Polarization", value: source.component || "Ez" });
      if (type === "gaussian") {
        const fwidth = Number(source.fwidth);
        items.push({ label: "Bandwidth Δf", value: fwidth > 0 ? `${fixed(fwidth)} c/µm` : "automatic" });
      }
      if (type === "gaussian_beam") {
        items.push({ label: "Beam waist w₀", value: `${fixed(source.beamWaist)} µm` });
        items.push({ label: "Direction", value: `${fixed(source.beamAngle, 1)}°` });
      }
      if (this.production && this.production.dimensions) {
        try {
          const [x, y] = canvasToMeep(this.production, Number(source.x), Number(source.y));
          items.push({ label: "Position", value: `(${fixed(x, 3)}, ${fixed(y, 3)}) µm` });
        } catch (err) {
          // produção antiga sem a escala do canvas
        }
      }
      const [width, height] = (source.waveSize || [0, 0]).map(v => Math.abs(Number(v) || 0));
      items.push({
        label: "Size",
        value: width || height ? `${fixed(width, 3)} × ${fixed(height, 3)} µm` : "Point source"
      });
      items.push({ label: "Extends into the PML", value: source.integrated === 1 ? "Yes" : "No" });
      return items;
    }
  }
};
</script>
